import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import PPA from './PPA';
import Loan from './Loan';
import TaxInputs from './TaxInputs';
import SolarInputs from './SolarInputs';
import UtilityInputs from './UtilityInputs';
import ESS from './ESS';
import SGIP from './SGIP';
import CAP from './CAP';
import OBS from './OBS';
import SMART from './SMART';
import CASH from './CASH';
import NYSERDA from './NYSERDA';
import ProjectAddress from './ProjectAddress';
import ProjectStatus from './ProjectStatus';


import './inputs.css';

class Inputs extends Component {
    toggle() {
        const { setInputsIsOpen, isOpen } = this.props;
        setInputsIsOpen(!isOpen);
    }

    render() {
        const { projectState, resiToggle, taxEntity } = this.props;

        return (
            <div>
                <div className="inputSections">
                    <ProjectStatus />
                </div>
                <div className="inputSections">
                    <ProjectAddress />
                </div>
                <div className="inputSections">
                    <UtilityInputs />
                </div>
                <div className="inputSections">
                    <SolarInputs />
                </div>
                <div className="inputSections">
                    <TaxInputs />
                </div>
                <div className="inputSections">
                    <ESS />
                </div>
                {projectState === 1 ? (
                    <div className="inputSections">
                        <SGIP />
                    </div>
                ) : null}
                {projectState === 2 ? (
                    <div className="inputSections">
                        <SMART />
                    </div>
                ) : null}
                {projectState === 4 ? (
                    <div className="inputSections">
                        <NYSERDA />
                    </div>
                ) : null}
                {resiToggle ? null :
                    <div>
                        <div className="inputSections">
                            <CAP />
                        </div>
                        {taxEntity ?
                            <div className="inputSections">
                                <OBS />
                            </div>
                            : null }
                        <div className="inputSections">
                            <PPA />
                        </div>
                    </div>
                }
                <div className="inputSections">
                    <Loan />
                </div>
                <div className="inputSections">
                    <CASH />
                </div>
            </div>
        );
    }
}

Inputs.propTypes = {
    isOpen: PropTypes.bool,
    setInputsIsOpen: PropTypes.func,
    projectState: PropTypes.number,
    resiToggle: PropTypes.bool.isRequired,
    taxEntity: PropTypes.bool.isRequired,
};

Inputs.defaultProps = {
    isOpen: null,
    setInputsIsOpen: null,
    projectState: null,
};


export default Inputs;



// WEBPACK FOOTER //
// ./src/containers/Inputs/Inputs.js